import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=8a5393c2&"
import script from "./HeaderMain.vue?vue&type=script&lang=js&"
export * from "./HeaderMain.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMain.vue?vue&type=style&index=0&id=8a5393c2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports